

export const AUTH_ROUTES = {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CREATE_PASSWORD: '/auth/create-password',
    SETUP_PASSWORD: '/auth/setup-password',
    VERIFY_EMAIL: '/auth/verify-email',
    CHECK_INBOX: '/auth/check-inbox',
    RESET_SUCCESS: '/auth/reset-success',
    JOIN_SUCCESS: '/auth/join-success',
    APPLICATION_FORM: '/auth/apply',
    APPLICATION_OTP: '/auth/application-otp',
    APPLICATION_SUCCESS: '/auth/application-success',
} as const;

export const AUTH_STORAGE_KEYS = {
    TOKEN: 'authToken',
    REFRESH_TOKEN: 'refreshToken',
    USER: 'authUser',
    REMEMBER_ME: 'rememberMe',
} as const;

// HTTP Status Codes
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
} as const;

// Professional roles for dropdown (used for candidate signup)
export const PROFESSIONAL_ROLES = [
    'Engineering & Development',
    'Product Management',
    'Design & Creative',
    'Data & Analytics',
    'Finance & Accounting',
    'Marketing & Communications',
    'Operations & Strategy',
    'Human Resources',
    'Legal & Compliance'
] as const;

// Industry options for company signup (uses same list as professional roles)
export const INDUSTRY_OPTIONS = PROFESSIONAL_ROLES;

// Company size options for company signup
export const COMPANY_SIZE_OPTIONS = [
    '0 - 50',
    '50 - 100',
    '100 - 250',
    '250 - 1000',
    '1000 - 5000',
    '+5000'
] as const;

export const AUTH_ERROR_MESSAGES = {
    INVALID_CREDENTIALS: 'We couldn\'t find an account with those credentials. Please check your email and password, then try again.',
    INCORRECT_PASSWORD: 'Your password is incorrect.',
    EMAIL_REQUIRED: 'Email is required',
    FIRST_NAME_REQUIRED: 'First name is required',
    LAST_NAME_REQUIRED: 'Last name is required',
    PASSWORD_REQUIRED: 'Password is required',
    NEW_PASSWORD_REQUIRED: 'New password is required',
    CONFIRM_PASSWORD_REQUIRED: 'Please confirm your password',
    PROFESSIONAL_ROLE_REQUIRED: 'Please select your professional role',
    COMPANY_NAME_REQUIRED: 'Company name is required',
    INDUSTRY_REQUIRED: 'Please select your industry',
    COMPANY_SIZE_REQUIRED: 'Please select company size',
    TERMS_REQUIRED: 'You must agree to the Terms of Use and Privacy Policy',
    INVALID_EMAIL: 'Please enter a valid email address',
    EMAIL_ALREADY_EXISTS: 'This Email address already exist',
    PASSWORD_TOO_SHORT: 'Must be at least 8 characters long',
    PASSWORDS_DONT_MATCH: 'Passwords do not match',
    INVALID_RESET_TOKEN: 'Invalid or expired reset link',
    NETWORK_ERROR: 'Network error. Please try again.',
    SERVER_ERROR: 'Server error. Please try again later.',
    EMAIL_NOT_FOUND: 'No account found with that email address',
    EMAIL_SENT_SUCCESS: 'We\'ve sent a password reset link to your email. It might take a minute or two to arrive. Be sure to check your spam folder too.',
    PASSWORD_RESET_SUCCESS: 'Your password has been reset. You can now use your new password to log in to your Hush account.',
};

export const VALIDATION_PATTERNS = {
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    STRONG_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
    NAME: /^[A-Za-z\s'.-]+$/,
} as const;

export const OAUTH_CONFIG = {
    GOOGLE: {
        clientId: '',
        redirectUri: `${window.location.origin}/auth/google/callback`,
        scope: ['email', 'profile'],
    },
    LINKEDIN: {
        clientId: '',
        redirectUri: `${window.location.origin}/auth/linkedin/callback`,
        scope: ['r_liteprofile', 'r_emailaddress'],
    },
} as const;
